export default "__VITE_ASSET__DH$T$nMb__"